var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .st0 {\n            fill: #006b87;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4685",
    className: "st0",
    d: "M14,6c0-1.1045694-.8954306-2-2-2s-2,.8954306-2,2,.8954306,2,2,2c1.1032019-.0032949,1.9967051-.8967981,2-2ZM14,18c0-1.1045704-.8954306-2-2-2s-2,.8954296-2,2,.8954306,2,2,2c1.1032019-.003294,1.9967051-.8967991,2-2ZM14,12c0-1.1045694-.8954306-2-2-2s-2,.8954306-2,2,.8954306,2,2,2c1.1032019-.0032949,1.9967051-.8967981,2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/Icon_More.5fc1b2c90e1675c58ffe03251d2f1115.svg";
export { ForwardRef as ReactComponent };